/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/log_in_medium'
export default icon
